<!-- this field is optional -->
<template>
  <div class="form__group--border pt-32 pb-16">
    <fieldset>
      <legend class="form__label pb-8">{{ legend }}</legend>
      <ul>
        <li v-for="ageRange in ageRanges" :key="ageRange.value">
          <PoppinsCheckbox
            v-model="ageGroups"
            :labelName="ageRange.optionText"
            :aria-label="generateScreenReaderLabel(ageRange.optionText)"
            :value="ageRange.value"
          />
        </li>
      </ul>
    </fieldset>
  </div>
</template>

<script lang="ts">
import Checkbox from '@/components/checkbox/Checkbox.vue';

export default {
  name: 'AgeGroupsCheckbox',
  components: {
    PoppinsCheckbox: Checkbox,
  },
  props: {
    ageRanges: {
      type: Object,
      required: true,
    },
    generateScreenReaderLabel: {
      type: Function,
      required: true,
    },
    legend: {
      type: String,
      required: true,
    },
  },
  computed: {
    ageGroups: {
      get() {
        return this.$store.getters.getFormField('ageGroups');
      },
      set(newValue) {
        return this.$store.dispatch('updateForm', { key: 'ageGroups', value: newValue });
      },
    },
  },
};
</script>
